module.exports = __webpack_public_path__ + "files/6482a1408371d7ddafeb0776bb5bdd47.png";